import React, { useState } from "react";
import { Form, Input, Button, Modal, Divider } from "antd";
import { TeamOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Avatar from "./Avatar";
import PhoneInput from "react-phone-input-2";
import "react-toastify/dist/ReactToastify.css";
import { error, success } from "../../Controllers/toast";
import { gql, useMutation } from "@apollo/client";
import { HashingPassword } from "../../Controllers/passwordHasher";

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 0,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 0,
    span: 24,
  },
};

// ChangeUserPassword
const CHANGE_USER_PASSWORD = gql`
  mutation Mutation($password: String!, $newPassword: String!) {
    ChangeUserPassword(password: $password, newPassword: $newPassword) {
      user_id
      firstname
      lastname
    }
  }
`;

const UsersForm = (props) => {
  const [changeUserPassword] = useMutation(CHANGE_USER_PASSWORD, {
    onCompleted: (res) => {
      console.log(res);
      if (res.ChangeUserPassword.user_id)
        success("رمزعبور شما با موفقیت تغییر کرد!");
    },
    onError: (err) => {
      // console.log(err.message);
      error(err.message ? err.message : "مشکلی رخ داده است!");
    },
  });
  // console.log(props)
  const data = props.user;
  const lang_choiced = useSelector((state) => state.lang_change);
  const [form] = Form.useForm();
  const onFinish = (value) => {
    // console.log(value);
    props.setUser(value);
  };
  const onFinishFailed = (err) => {
    // console.log(err);
    error_notify();
  };

  const error_notify = () => toast.error("مشکلی رخ داده است!");
  const [buttonTitr, setButtonTitr] = useState(
    lang_choiced.pages.user.btnChange
  );
  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const showModal = () => {
    setVisible(true);
  };
  const handleOk = () => {
    setLoading(true);
    return new Promise((resolve, reject) => {
      setTimeout(
        1 > 0.5
          ? resolve(
              setLoading(false),
              setVisible(false),
              setDisable(true),
              setButtonTitr(lang_choiced.pages.user.btnChange),
              form.submit()
            )
          : reject(),
        4000
      );
    }).catch((e) => {
      error("مشکلی رخ داده است!");
      // console.log(lang_choiced.components.profile.userForm.rejectError, e)
    });
  };

  const handleCancel = () => {
    setVisible(false);
  };
  // console.log(data , "is user");
  return (
    <div>
      {/* <ToastContainer rtl={true} /> */}
      <Modal
        open={visible}
        title={lang_choiced.pages.user.modal.title}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button type="danger" key="back" onClick={handleCancel}>
            {lang_choiced.pages.user.modal.btnClose}
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleOk}
          >
            {lang_choiced.pages.user.btnSave}
          </Button>,
        ]}
      >
        <p>{lang_choiced.pages.user.modal.text}</p>
      </Modal>
      <p>تغییر رمزعبور</p>
      <Form
        // form={form}
        name="password"
        onFinish={async (value) => {
          // await HashingPassword
          const password = await HashingPassword(value.password);
          const newPassword = await HashingPassword(value.newPassword);
          // console.log(password, newPassword, "is password");
          changeUserPassword({
            variables: {
              password,
              newPassword,
            },
          });
        }}
        onFinishFailed={(err) => console.log(err)}
      >
        <Form.Item label="رمزعبور فعلی" name={"password"}>
          <Input.Password />
        </Form.Item>
        <Form.Item label="رمزعبور جدید" name={"newPassword"}>
          <Input.Password />
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" type="primary">
            تنظیم رمزعبور جدید
          </Button>
        </Form.Item>
      </Form>
      <Divider />
      <Form
        {...layout}
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        name="profile"
        layout="vertical"
        initialValues={
          data
            ? {
                lastname: data.lastname,
                email: data.email,
                firstname: data.firstname,
                mobile: data.mobile,
                website: data.website,
                country: data.country,
                city: data.city,
                coname: data.coname,
                address: data.address,
                postcode: data.postcode,
                cotel: data.cotel,
              }
            : {
                lastname: "",
                email: "",
                firstname: "",
                mobile: "",
                website: "",
                country: "",
                city: "",
                coname: "",
                address: "",
                postcode: "",
                cotel: "",
              }
        }
      >
        <Form.Item {...tailLayout}>
          {disable === true ? (
            <Button
              onClick={() => {
                setDisable(false);
                setButtonTitr(lang_choiced.pages.user.btnSave);
              }}
              htmlType="button"
              type="dashed"
            >
              {buttonTitr}
            </Button>
          ) : (
            <Button
              onClick={() => {
                showModal();
              }}
              htmlType="button"
              type="dashed"
            >
              {buttonTitr}
            </Button>
          )}
        </Form.Item>

        <Form.Item
          {...tailLayout}
          label={
            <span>
              <TeamOutlined className="Icon-style" />{" "}
              {lang_choiced.pages.user.forms.first_name} :{" "}
            </span>
          }
          name="firstname"
          rules={[
            {
              required: true,
              message: lang_choiced.pages.user.rules.first_name,
            },
          ]}
          className=""
        >
          <Input
            disabled={disable}
            size="large"
            className="login-form-style "
          />
        </Form.Item>
        <Form.Item
          {...tailLayout}
          label={
            <span>
              <TeamOutlined className="Icon-style" />{" "}
              {lang_choiced.pages.user.forms.last_name} :{" "}
            </span>
          }
          name="lastname"
          rules={[
            {
              required: true,
              message: lang_choiced.pages.user.rules.last_name,
            },
          ]}
          className=""
        >
          <Input
            disabled={disable}
            size="large"
            className="login-form-style "
          />
        </Form.Item>

        <Form.Item
          {...tailLayout}
          label={
            <span>
              <TeamOutlined className="Icon-style" />{" "}
              {lang_choiced.pages.user.forms.email} :{" "}
            </span>
          }
          name="email"
          rules={[
            {
              required: true,
              message: lang_choiced.pages.user.rules.email,
            },
            {
              type: "email",
              message: lang_choiced.pages.user.rules.correctEmailPattern,
            },
          ]}
          className=""
        >
          <Input
            disabled={disable}
            size="large"
            type="email"
            className="login-form-style input-ltr"
          />
        </Form.Item>
        <Form.Item
          {...tailLayout}
          label={
            <span>
              <TeamOutlined className="Icon-style" />{" "}
              {lang_choiced.pages.user.forms.company_name} :{" "}
            </span>
          }
          name="coname"
          // rules={[{ required: true, message: "لطفا نام شرکت خود را وارد کنید !" }]}
          className=""
        >
          <Input
            disabled={disable}
            size="large"
            className="login-form-style input-ltr"
          />
        </Form.Item>
        <Form.Item
          {...tailLayout}
          label={
            <span>
              <TeamOutlined className="Icon-style" />{" "}
              {lang_choiced.pages.user.forms.mobile} :{" "}
            </span>
          }
          name="mobile"
          rules={[
            { required: true, message: lang_choiced.pages.user.rules.mobile },
          ]}
          className=""
          hasFeedback
        >
          <PhoneInput
            disabled={disable}
            style={{
              direction: "ltr",
              textAlign: "left",
              width: "100% !important",
            }}
            country="ir"
            regions={[
              "north-america",
              "south-america",
              "central-america",
              "carribean",
              "eu-union",
              "ex-ussr",
              "ex-yugos",
              "baltic",
              "middle-east",
              "north-africa",
            ]}
            enableSearch
          />
        </Form.Item>
        <Form.Item
          {...tailLayout}
          label={
            <span>
              <TeamOutlined className="Icon-style" />{" "}
              {lang_choiced.pages.user.forms.website} :{" "}
            </span>
          }
          name="website"
          className=""
          // rules={[{ type: "url", message: "لطفا شکل صحیح را وارد کنید !" }]}
        >
          <Input
            disabled={disable}
            size="large"
            className="login-form-style input-ltr"
          />
        </Form.Item>
        <Form.Item
          {...tailLayout}
          label={
            <span>
              <TeamOutlined className="Icon-style" />{" "}
              {lang_choiced.pages.user.forms.country} :{" "}
            </span>
          }
          name="country"
          // rules={[{ required: true, message: "لطفا کشور خود را وارد کنید !" }]}
          className=""
        >
          <Input
            disabled={disable}
            size="large"
            className="login-form-style "
          />
        </Form.Item>
        <Form.Item
          {...tailLayout}
          label={
            <span>
              <TeamOutlined className="Icon-style" />{" "}
              {lang_choiced.pages.user.forms.city} :{" "}
            </span>
          }
          name="city"
          // rules={[{ required: true, message: "لطفا شهر خود را وارد کنید !" }]}
          className=""
        >
          <Input
            disabled={disable}
            size="large"
            className="login-form-style "
          />
        </Form.Item>
        <Form.Item
          {...tailLayout}
          label={
            <span>
              <TeamOutlined className="Icon-style" />{" "}
              {lang_choiced.pages.user.forms.address} :{" "}
            </span>
          }
          name="address"
          // rules={[{ required: true, message: "لطفا آدرس خود را وارد کنید !" }]}
          className=""
        >
          <Input
            disabled={disable}
            size="large"
            className="login-form-style "
          />
        </Form.Item>
        <Form.Item
          {...tailLayout}
          label={
            <span>
              <TeamOutlined className="Icon-style" />{" "}
              {lang_choiced.pages.user.forms.co_tel} :{" "}
            </span>
          }
          name="cotel"
          // rules={[
          //   { required: true, message: "لطفا تلفن شرکت خود را وارد کنید !" },
          // ]}
          className=""
        >
          <Input
            disabled={disable}
            size="large"
            // type="number"
            className="login-form-style input-ltr"
          />
        </Form.Item>
        <Form.Item
          {...tailLayout}
          label={
            <span>
              <TeamOutlined className="Icon-style" />{" "}
              {lang_choiced.pages.user.forms.post_code} :{" "}
            </span>
          }
          name="postcode"
          // rules={[
          //   { required: true, message: "لطفا کدپستی خود را وارد کنید !" },
          // ]}
          className=""
        >
          <Input
            disabled={disable}
            size="large"
            type="number"
            className="login-form-style input-ltr"
          />
        </Form.Item>
      </Form>
    </div>
  );
};

export default UsersForm;
